var ConfigureConsts = /** @class */ (function () {
    function ConfigureConsts() {
    }
    ConfigureConsts.event = {
        graphSettingEventName: 'gallery.shown',
        dynamicSettingEventName: 'dynamic.shown',
        controlSettingEventName: 'controlSetting.shown',
        zoomChangedEventName: 'configure.designer.zoomChanged'
    };
    return ConfigureConsts;
}());
export { ConfigureConsts };
